const state = {
  siderCollapsed: false,
  userInfo: {},
  appEnv: {
    prod: process.env.VUE_APP_RELEASE === 'prod',
    appId: '',
    appKey: '',
    platformId: null,
  }
};

const actions = {
  saveUserInfo({commit}, user) {
    commit('SaveUserInfo', user)
  },
  saveAppEnv({commit}, data) {
    commit('SaveAppEnv', data)
  },
  clearAppEnv({commit}) {
    commit('ClearAppEnv')
  },
};

const mutations = {
  toggleCollapse(state) {
    state.siderCollapsed = !state.siderCollapsed;
  },
  SaveUserInfo: (state, user) => {
    state.userInfo = user
  },
  SaveAppEnv: (state, data) => {
    state.appEnv = data
  },
  ClearAppEnv: (state) => {
    state.appEnv = {
      prod: process.env.VUE_APP_RELEASE === 'prod',
      appId: '',
      platformId: null,
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
